import { initReactI18next } from 'react-i18next'

import i18n, { use } from 'i18next'
import detector from 'i18next-browser-languagedetector'

import { setupTranslations as setupAccountSettingsTranslations } from '@surglogs-app/account-settings'
import { setupTranslations as setupAuthTranslations } from '@surglogs-app/auth'
import { setupTranslations as setupPromoModalTranslations } from '@surglogs-app/promo-modal'
import { setupTranslations as setupRemindersEditorTranslations } from '@surglogs-app/reminders-editor'
import { BootstrapHook } from '@surglogs-app/types'
import { setupTranslations as setupDialogTranslations } from '@surglogs-app/ui.dialog'
import { setupTranslations as setupErrorTranslations } from '@surglogs-app/ui.error'
import { setupTranslations as setupFileTranslations } from '@surglogs-app/ui.file'
import { setupTranslations as setupFormTranslations } from '@surglogs-app/ui.form'
import { setupTranslations as setupLoaderTranslations } from '@surglogs-app/ui.loader'
import { setupTranslations as setupSignatureTranslations } from '@surglogs-app/ui.signature'
import { setupTranslations as setupToastTranslations } from '@surglogs-app/ui.toast'

import { TranslationNamespace } from '../../constants/TranslationNamespace'
import { messages as screensTranslations } from '../../screens/messages'

export const initI18n: BootstrapHook = () => {
  use(detector)
    .use(initReactI18next)
    .init({
      // TODO: global messages are should be removed and moved into root app
      resources: {
        en: {
          [TranslationNamespace.SCREENS]: screensTranslations as any,
        },
      },
      debug: process.env.NODE_ENV === 'development',
      lng: 'en',
      fallbackLng: 'en',
      keySeparator: '.',
      // partialBundledLanguages: true,
      interpolation: { escapeValue: false },
    })

  setupToastTranslations(i18n)
  setupLoaderTranslations(i18n)
  setupDialogTranslations(i18n)
  setupAuthTranslations(i18n)
  setupFileTranslations(i18n)
  setupErrorTranslations(i18n)
  setupSignatureTranslations(i18n)
  setupFormTranslations(i18n)
  setupPromoModalTranslations(i18n)
  setupRemindersEditorTranslations(i18n)
  setupAccountSettingsTranslations(i18n)
}
